import React, { useState, useEffect, useContext } from "react";
import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { FaSearch, FaPrint } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { ThemeContext } from "../context/ThemeContext";
import getCurrentSkin from "../utils/getCurrentSkin";


const LedgerItemWiseReport = () => {
  const { isDark, skin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;
  const [branchType, setBranchType] = useState("HO");
  const [branchId, setBranchId] = useState(8);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [equipment, setEquipment] = useState("Own");

  const [branchList, setBranchList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [data, setData] = useState([]);

  // Fetch branch and item dropdowns
  useEffect(() => {
    axios
      .get(`https://nissi-india.com/api/po_fillDropdowns?branchid=8&branchtype=HO`)
      .then((res) => {
        const stores = res.data.data?.stores || [];
        setBranchList(stores);
      })
      .catch((err) => {
        console.error("Dropdown fetch failed", err);
        toast.error("Failed to load branch dropdown");
      });

    // Fetch items for dropdown
   
  }, [branchType]);

  const handleSearch = () => {
    const payload = {
      supplierCode:"SUPP/37/0007",
      from: fromDate,
      to: toDate,
      branch: branchId
    };

    console.log("payload", payload);

    axios
      .get("https://www.nissi-india.com/api/grnSupplier_ledgerInside",{params:payload})
      .then((res) => {
        setData(res.data.data || []);
        console.log("response:", res.data);
      })
      .catch((err) => {
        console.error("Fetch failed", err);
        toast.error("Failed to fetch ItemWise report");
      });
  };

  return (
    <LayoutWrapper>
      <HeaderBar title="LEDGER ITEMWISE REPORT" />
      <ToastContainer />

      <div
        className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-black"
            : `bg-white ${currentSkin.glass} text-black`
        }`}
      >
        {/* Branch Type */}
        <div className="flex gap-6 mb-4">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="branchtype"
              value="HO"
              checked={branchType === "HO"}
              onChange={() => setBranchType("HO")}
            />
            HO
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="branchtype"
              value="BO"
              checked={branchType === "BO"}
              onChange={() => setBranchType("BO")}
            />
            BO
          </label>
        </div>

        {/* Filters */}
        <div className="grid grid-cols-2 gap-6 mb-4">
          <div>
            <label>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="w-full border px-2 py-1"
            />
          </div>

          <div>
            <label>To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="w-full border px-2 py-1"
            />
          </div>

          <div>
            <label>Branch</label>
            <select
              className="w-full border px-2 py-1"
              value={branchId}
              onChange={(e) => setBranchId(e.target.value)}
            >
              <option value="">Select</option>
              {branchList.map((b) => (
                <option key={b.fld_storeid} value={b.fld_storeid}>
                  {b.fld_storename}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Item Code</label>
            <input
              type="text"
              value={itemCode}
              onChange={(e) => setItemCode(e.target.value)}
              className="w-full border px-2 py-1"
            />
          </div>

          <div>
            <label>Item Name</label>
            <select
              className="w-full border px-2 py-1"
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
            >
              <option value="">Select</option>
              {itemList.map((i) => (
                <option key={i.fld_itemid} value={i.fld_itemname}>
                  {i.fld_itemname}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Equipment</label>
            <select
              className="w-full border px-2 py-1"
              value={equipment}
              onChange={(e) => setEquipment(e.target.value)}
            >
              <option value="Own">Own</option>
              <option value="Hire">Hire</option>
            </select>
          </div>
        </div>

        {/* Search Button */}
        <div className="flex justify-center gap-4 mt-4">
          <button
            onClick={handleSearch}
            className="flex items-center gap-2 bg-blue-600 text-white px-6 py-2 rounded"
          >
            <FaSearch /> Search
          </button>
        </div>

        {/* Grid */}
        <div className="mt-4">
          {data.length === 0 ? (
            <div className="text-center text-gray-500">No Records Found!</div>
          ) : (
            <table className="w-full border text-sm">
               <thead className={`bg-${baseColor}-${baseShade} text-white`}>
                <tr>
                  <th className="border px-2 py-1">SlNo</th>
                  <th className="border px-2 py-1">Date</th>
                  <th className="border px-2 py-1">Veh/Dep Code</th>
                  <th className="border px-2 py-1">Veh/Dep Name/No</th>
                  <th className="border px-2 py-1">Item Code</th>
                  <th className="border px-2 py-1">Item Name</th>
                  <th className="border px-2 py-1">UOM</th>
                  <th className="border px-2 py-1">Qty</th>
                  <th className="border px-2 py-1">Rate</th>
                  <th className="border px-2 py-1">Amount</th>
                  <th className="border px-2 py-1">Print</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, idx) => (
                  <tr key={idx} className="hover:bg-gray-50">
                    <td className="border px-2 py-1">{idx + 1}</td>
                    <td className="border px-2 py-1">{row.date}</td>
                    <td className="border px-2 py-1">{row.vehDepCode}</td>
                    <td className="border px-2 py-1">{row.vehDepName}</td>
                    <td className="border px-2 py-1">{row.itemCode}</td>
                    <td className="border px-2 py-1">{row.itemName}</td>
                    <td className="border px-2 py-1">{row.uom}</td>
                    <td className="border px-2 py-1">{row.qty}</td>
                    <td className="border px-2 py-1">{row.rate}</td>
                    <td className="border px-2 py-1">{row.amount}</td>
                    <td className="border px-2 py-1 text-center">
                      <button className="text-blue-600 hover:text-blue-800">
                        <FaPrint />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </LayoutWrapper>
  );
};

export default LedgerItemWiseReport;
